import React, { useState } from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  useBreakpointValue
} from '@chakra-ui/react';
import { AddIcon, MinusIcon } from '@chakra-ui/icons';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

/**
 * Course FAQ Section
 * Frequently asked questions
 */
const CourseFAQ = ({ data }) => {
  if (!data) return null;

  const {
    title = "Frequently Asked Questions",
    subtitle,
    faqItems = []
  } = data;

  if (faqItems.length === 0) return null;

  return (
    <Box py={{ base: 16, md: 20 }} bg="gray.50" borderTop="1px solid" borderColor="gray.200">
      <Container maxW="container.md">
        {/* Header */}
        <MotionBox
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
          mb={{ base: 12, md: 16 }}
        >
          <VStack align="center" spacing={3} textAlign="center">
            <Heading as="h2" size="2xl" fontWeight="900" color="gray.900">
              {title}
            </Heading>
            {subtitle && (
              <Text fontSize="lg" color="gray.600">
                {subtitle}
              </Text>
            )}
          </VStack>
        </MotionBox>

        {/* FAQ Accordion */}
        <MotionBox
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <Accordion allowMultiple defaultIndex={[0]}>
            {faqItems.map((item, idx) => (
              <AccordionItem key={idx} border="1px solid" borderColor="gray.200" mb={3} borderRadius="lg" overflow="hidden">
                {({ isExpanded }) => (
                  <>
                    <AccordionButton
                      bg={isExpanded ? 'brand.50' : 'white'}
                      px={6}
                      py={4}
                      _hover={{ bg: 'brand.50' }}
                      transition="background 0.2s"
                    >
                      <Heading
                        as="h3"
                        size="sm"
                        flex={1}
                        textAlign="left"
                        color="gray.900"
                        fontWeight="600"
                      >
                        {item.question}
                      </Heading>
                      <Box color="brand.600" ml={4} flexShrink={0}>
                        {isExpanded ? <MinusIcon /> : <AddIcon />}
                      </Box>
                    </AccordionButton>
                    <AccordionPanel pb={4} px={6} pt={4} bg="white" color="gray.700" fontSize="sm" lineHeight="1.6">
                      {item.answer}
                    </AccordionPanel>
                  </>
                )}
              </AccordionItem>
            ))}
          </Accordion>
        </MotionBox>
      </Container>
    </Box>
  );
};

export default CourseFAQ;
